import classes from './PopinSubtitle.module.css';

interface props {
  readonly text: string
}

export default function PopinSubtitle({text}:props){
  return <div className={classes.title}>{text}</div>;
}